import multicreationCampaignCreateFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_campaign_create_form_submit';

import { BiddingStrategy } from 'store/models/auctionData';
import { AuctionsToCreate } from 'store/models/multiCreation';

interface SendMulticreationCampaignCreateFormSubmitProps {
    auctionsToCreate: AuctionsToCreate;
    createdCampaignVacancyIds?: string[];
    biddingStrategy: BiddingStrategy;
    failedVacancyIds?: number[];
    errors?: string;
}

const divideBy100 = (value: string): string => (Number(value) / 100).toString();

export const sendMulticreationCampaignCreateFormSubmit = ({
    auctionsToCreate,
    createdCampaignVacancyIds,
    failedVacancyIds,
    biddingStrategy,
    errors,
}: SendMulticreationCampaignCreateFormSubmitProps): void => {
    const auctionsToCreateWithDividedValues = Object.entries(auctionsToCreate).reduce<AuctionsToCreate>(
        (acc, [vacancyId, auctionItem]) => {
            const vacancyIdNumber = Number(vacancyId);

            acc[vacancyIdNumber] = {
                ...auctionItem,
                bid: divideBy100(auctionItem.bid),
                budget: divideBy100(auctionItem.budget),
                biddingStrategy,
            };

            return acc;
        },
        {}
    );

    multicreationCampaignCreateFormSubmit({
        auctionsToCreate: JSON.stringify(auctionsToCreateWithDividedValues),
        ...(createdCampaignVacancyIds && { createdCampaignVacancyIds: createdCampaignVacancyIds.toString() }),
        ...(failedVacancyIds && { failedVacancyIds: failedVacancyIds.toString() }),
        ...(errors && { errors }),
    });
};
